export default "__VITE_ASSET__DKPLVBGp__"